module.exports = __webpack_public_path__ + "static/media/prev-page.f26c2525.svg";